(function($) {
  Drupal.behaviors.faqTemplate = {
    attached: false,
    attach: function(context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var self = this;
      var $template = $('.js-faq-template', context);
      var $trigger = $('.js-faq-toggle', $template);

      // Check if this has a trigger
      if ($trigger.length > 0) {
        // Toggle the nav
        $trigger.once().on('click', function() {
          self.toggleFaqContainer($(this));
        }).on('keydown', function (event) {
          if (event.key === "Enter") {
            self.toggleFaqContainer($(this));
          }
        });
      }
    },
    toggleFaqContainer: function ($trigger) {
      var $parent = $trigger.parent();
      var $isFormatter = $trigger.hasClass('faq-formatter__toggle');
      var $content = $isFormatter ? $parent.next('.js-faq-content') : $trigger.next('.js-faq-content');
      var expanded = false;
      
      // Switch the states of aria-expanded and aria-hidden
      if ($trigger[0].hasAttribute('aria-expanded')) {
        expanded = $trigger.attr('aria-expanded') !== 'false';
        $trigger.attr('aria-expanded', !expanded);
      } else {
        expanded = $parent.attr('aria-expanded') !== 'false';
        $parent.attr('aria-expanded', !expanded);
      }
      $content.attr('aria-hidden', expanded);
    },
  };
})(jQuery);
